const Component = () => import('./OrderTracking');

export { Component };
